export const GET_STICKY_COLUMNS = "GET_STICKY_COLUMNS";
export const GET_STICKY_COLUMNS_SUCCESS = "GET_STICKY_COLUMNS_SUCCESS";
export const GET_STICKY_COLUMNS_ERROR = "GET_STICKY_COLUMNS_ERROR";

export const UPDATE_STICKY_COLUMNS = "UPDATE_STICKY_COLUMNS";
export const UPDATE_STICKY_COLUMNS_SUCCESS = "UPDATE_STICKY_COLUMNS_SUCCESS";
export const UPDATE_STICKY_COLUMNS_ERROR = "UPDATE_STICKY_COLUMNS_ERROR";